import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import { arrayToCsv, downloadCsv } from "../../../Utils/Utils";

/**
* Class ExportCSV
* Generic component to generate status bar
**/
class ExportCSV extends Component {
  /**
  * props
  * parent : parent component
  **/

  /**
  * render
  * Rendering component function : display the status bar
  **/
  render() {
    return (
      <div className="btnExportGrid">
        <Button bsStyle="primary" onClick={this.props.customFn instanceof Function ? this.props.customFn : this.export.bind(this)}>Exporter</Button>
      </div>
    )
  }

  /**
  * export
  * Export clients as CSV
  **/
  export() {
    if(!this.props.parent || !this.props.gridRef) return;

    const grid = this.props.parent.refs[`grid${this.props.gridRef}`];
    if(!grid) return;

    const table = grid.refs[`table${this.props.gridRef}`];
    const data = table.getTableDataIgnorePaging();
    const columnsInfo = table.store.colInfos;
    let arrData = [];
    let columnsName = [];

    // Fill columns
    for(const columnName in columnsInfo) {
      const column = columnsInfo[columnName];

      if(this.props.fields instanceof Array) {
        if(this.props.fields.includes(column.text)) columnsName.push(column.text);
        else {
          for(const fieldIdx in this.props.fields) {
            const field = this.props.fields[fieldIdx];
            if(field instanceof Object && field.fieldName === columnName) {
              columnsName.push(field.title);
            }
          }
        }
      } else {
        if(!column.hidden) columnsName.push(column.text);
      }
    }

    arrData.push(columnsName);

    // Fill data
    data.forEach(
      (obj, index) => {
        const arrObj = [];

        for(const columnId in columnsInfo) {
          const column = columnsInfo[columnId];

          if(column.name !== "actions") {
            if((this.props.fields instanceof Array && this.props.fields.includes(column.text))
                || (!this.props.fields && !column.hidden)) {

              let value = obj[column.name];

              if(column.format instanceof Function)
                value = column.format.call(grid, value, obj, column.formatExtraData, false);

              if(typeof value === "string") value = value.replace(/\n/g, " ");
              if(typeof value === "string") value = value.replace(/;/g, ",");

              arrObj.push(value);

            } else if (this.props.fields instanceof Array) {
              for(const fieldIdx in this.props.fields) {
                const field = this.props.fields[fieldIdx];
                if(field instanceof Object && field.fieldName === columnId) {

                  let value = obj[column.name];

                  if(column.format instanceof Function)
                    value = column.format.call(grid, value, obj, { fields: field.extrafields }, false);

                  if(typeof value === "string") value = value.replace(/\n/g, " ");
                  if(typeof value === "string") value = value.replace(/;/g, ",");

                  arrObj.push(value);
                }
              }
            }
          }

        }

        arrData.push(arrObj);
      }
    );

    const csv = arrayToCsv(arrData);
    downloadCsv(csv, this.props.gridRef);
  }

}

export default ExportCSV;



// WEBPACK FOOTER //
// ./src/views/Helper/Grid/ExportCSV.js